
import React, {ReactElement, FC, useState, useEffect} from "react";
import {Box, Typography} from "@mui/material";
import Markdown from 'markdown-to-jsx';
import about from './markdown/about.md';
import "./styles/About.css"
import TimeLine from "../components/Timeline/Timeline"
import EducationTimeLine from "../data/EducationTimelineData.json"

const About: FC<any> = (): ReactElement => {
    let [ content, setContent] = useState({md: ""});
    useEffect(()=> {
        fetch(about)
            .then((res) => res.text())
            .then((md) => {
                setContent({ md })
            })
    }, [])
    return (
        <Box sx={{
            flexGrow: 1,
            backgroundColor: 'whitesmoke',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <div className="about-container">
            <Typography variant="h3">About</Typography>
            <div className="post">
                <Markdown children={content.md}/>
            </div>
            <TimeLine title="Education" TimeLineData={EducationTimeLine}/>
            </div>
            
        </Box>
        
    );
};

export default About;
